import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '../../services/api';
import PaymentRequestForm from './PaymentRequestForm';
import styles from './PaymentRequests.module.css';

export default function PaymentRequestsPage({ user, dbUser }) {
  const [bankAccounts, setBankAccounts] = useState([]);
  const [editing, setEditing] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [formKey, setFormKey] = useState(0);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const load = async () => {
    try {
      const accounts = await api.getBankAccounts(user.credential);
      setBankAccounts(accounts);

      // Check if editing an existing request
      const editId = searchParams.get('edit');
      if (editId) {
        const requests = await api.getPaymentRequests(user.credential);
        const toEdit = requests.find(r => r.id === parseInt(editId) && r.status === 'Open');
        if (toEdit) setEditing(toEdit);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []); // eslint-disable-line

  const handleSave = async (form, afterSaveCallback) => {
    setSubmitting(true);
    try {
      let createdId = null;
      if (editing?.id) {
        await api.updatePaymentRequest(user.credential, editing.id, form);
        createdId = editing.id;
      } else {
        const created = await api.createPaymentRequest(user.credential, form);
        createdId = created?.id;
      }
      if (afterSaveCallback) await afterSaveCallback(createdId);
      setEditing(null);
      setFormKey(k => k + 1);
      navigate('/my-history');
    } catch (e) {
      alert('שגיאה בשליחת הבקשה');
      console.error(e);
    } finally {
      setSubmitting(false);
    }
  };

  const handleAccountCreated = (newAccount) => {
    setBankAccounts(prev => [...prev, newAccount]);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2>הגשת בקשת תשלום</h2>
      </div>

      {loading && <p className={styles.empty}>טוען...</p>}

      {!loading && (
        <PaymentRequestForm
          key={formKey}
          request={editing}
          bankAccounts={bankAccounts}
          onSave={handleSave}
          onCancel={editing ? () => { setEditing(null); navigate('/my-history'); } : () => {}}
          user={user}
          onAccountCreated={handleAccountCreated}
          hideCancelButton={!editing}
          submitting={submitting}
        />
      )}
    </div>
  );
}
